// <s-view-cursor> moves a decorative "View" bubble to follow the pointer inside a product card's media.
// Fine pointers only; touch and keyboard users never see it (the card link itself stays the action).
class SViewCursor extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal, passive: true };
    this.addEventListener('pointerenter', (event) => this.#move(event), opts);
    this.addEventListener('pointermove', (event) => this.#move(event), opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #move(event) {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      const rect = this.getBoundingClientRect();
      this.style.setProperty('--vx', `${event.clientX - rect.left}px`);
      this.style.setProperty('--vy', `${event.clientY - rect.top}px`);
    });
  }
}

if (!customElements.get('s-view-cursor')) customElements.define('s-view-cursor', SViewCursor);
